export const SHIPMENT_STATUSES = strings => ({
  pending: strings.pending,
  delayed: strings.delayed,
  shipped: strings.shipped,
  delivered: strings.delivered,
  canceled: strings.canceled
})
